<template>
    <div>
        <h4 class="font-medium leading-normal text-gray-600">
            Subscription details
        </h4>
        <p v-if="user.app_type === null || user.app_type === 'both'" class="text-sm leading-normal text-gray-500">
            Your Plugin subscription breakdown. For PRO subscription details
            <inertia-link
                :href="route('billing.pro-subscriptions.index')"
                class="text-sm font-medium leading-normal text-topol-blue-500 hover:text-topol-blue-600"
                >click here</inertia-link
            >.
        </p>
        <p v-else class="text-sm leading-normal text-gray-500">
            Your Plugin subscription breakdown.
        </p>

        <div
            v-if="
                !pluginSubscription &&
                (shouldDisplayPluginTrialBanner ||
                    shouldDisplayPluginSubscriptionBanner)
            "
            class="mt-4 flex flex-col items-start rounded bg-yellow-100 px-[14px] pb-2.5 pt-3 sm:flex-row"
        >
            <div>
                <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M8.25685 3.0991C9.02185 1.7391 10.9788 1.7391 11.7428 3.0991L17.3228 13.0191C18.0728 14.3531 17.1098 15.9991 15.5808 15.9991H4.41985C2.88985 15.9991 1.92685 14.3531 2.67685 13.0191L8.25685 3.0991ZM10.9998 13.0001C10.9998 13.2653 10.8945 13.5197 10.707 13.7072C10.5194 13.8947 10.2651 14.0001 9.99985 14.0001C9.73463 14.0001 9.48028 13.8947 9.29274 13.7072C9.10521 13.5197 8.99985 13.2653 8.99985 13.0001C8.99985 12.7349 9.10521 12.4805 9.29274 12.293C9.48028 12.1055 9.73463 12.0001 9.99985 12.0001C10.2651 12.0001 10.5194 12.1055 10.707 12.293C10.8945 12.4805 10.9998 12.7349 10.9998 13.0001ZM9.99985 5.0001C9.73463 5.0001 9.48028 5.10546 9.29274 5.29299C9.10521 5.48053 8.99985 5.73488 8.99985 6.0001V9.0001C8.99985 9.26532 9.10521 9.51967 9.29274 9.70721C9.48028 9.89474 9.73463 10.0001 9.99985 10.0001C10.2651 10.0001 10.5194 9.89474 10.707 9.70721C10.8945 9.51967 10.9998 9.26532 10.9998 9.0001V6.0001C10.9998 5.73488 10.8945 5.48053 10.707 5.29299C10.5194 5.10546 10.2651 5.0001 9.99985 5.0001Z"
                        fill="#D69E2E"
                    />
                </svg>
            </div>
            <div class="mt-3 text-sm sm:ml-[14px] sm:mt-0">
                <p
                    v-if="
                        shouldDisplayPluginTrialBanner &&
                        user.plugin_trial_ends_at
                    "
                    class="font-medium text-yellow-800"
                >
                    Your free 14-days trial period has ended on
                    {{
                        format(
                            new Date(user.plugin_trial_ends_at),
                            'MMMM d, yyyy'
                        )
                    }}.
                </p>
                <p class="text-yellow-700">
                    Your Plugin API Tokens are now suspended, please select
                    appropriate Plugin subscription to continue.
                </p>
            </div>
        </div>
        <div
            v-if="!pluginSubscription && shouldAllowTrial"
            class="mt-4 flex flex-col items-start rounded bg-blue-100 px-[14px] pb-2.5 pt-3 sm:flex-row"
        >
            <div class="mt-0.5">
                <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8ZM9 4C9 4.26522 8.89464 4.51957 8.70711 4.70711C8.51957 4.89464 8.26522 5 8 5C7.73478 5 7.48043 4.89464 7.29289 4.70711C7.10536 4.51957 7 4.26522 7 4C7 3.73478 7.10536 3.48043 7.29289 3.29289C7.48043 3.10536 7.73478 3 8 3C8.26522 3 8.51957 3.10536 8.70711 3.29289C8.89464 3.48043 9 3.73478 9 4ZM7 7C6.73478 7 6.48043 7.10536 6.29289 7.29289C6.10536 7.48043 6 7.73478 6 8C6 8.26522 6.10536 8.51957 6.29289 8.70711C6.48043 8.89464 6.73478 9 7 9V12C7 12.2652 7.10536 12.5196 7.29289 12.7071C7.48043 12.8946 7.73478 13 8 13H9C9.26522 13 9.51957 12.8946 9.70711 12.7071C9.89464 12.5196 10 12.2652 10 12C10 11.7348 9.89464 11.4804 9.70711 11.2929C9.51957 11.1054 9.26522 11 9 11V8C9 7.73478 8.89464 7.48043 8.70711 7.29289C8.51957 7.10536 8.26522 7 8 7H7Z"
                        fill="#3182CE"
                    />
                </svg>
            </div>
            <div class="mt-3 text-sm sm:ml-[14px] sm:mt-0">
                <p class="text-blue-600">
                    You can try Topol Plugin for
                    <span class="font-medium">14-days FREE Trial</span> period
                    or choose your preferred Plugin Plan right now.
                </p>
            </div>
        </div>

        <div
            v-if="!pluginSubscription"
            class="mt-3 rounded-md border border-gray-200 bg-gray-50 px-6 pb-7 pt-4"
        >
            <div>
                <div class="flex flex-wrap justify-between">
                    <div class="max-w-md 2xl:max-w-lg">
                        <h3
                            class="text-2xl font-bold leading-normal tracking-tighter text-gray-800"
                        >
                            Choose your Plugin subscription plan
                        </h3>

                        <p class="text-sm leading-normal text-gray-500">
                            All plans offer the same features, only difference
                            is number of allowed users.
                        </p>
                    </div>
                </div>

                <div v-for="plan in orderedSubscriptionPlans" :key="plan.id">
                    <div
                        class="mt-6 w-full cursor-pointer rounded-md border bg-white pb-[22px] pl-4 pr-4 pt-[18px] transition duration-200 ease-in-out sm:pr-6"
                        :class="{
                            'border-gray-200': pluginPlanUuid !== plan.uuid,
                            'border-orange-500': pluginPlanUuid === plan.uuid,
                        }"
                        @click="pluginPlanUuid = plan.uuid"
                    >
                        <div
                            class="flex flex-col sm:flex-row sm:justify-between"
                        >
                            <div class="flex">
                                <div class="hidden sm:block">
                                    <RadioInput
                                        v-model="pluginPlanUuid"
                                        :option="plan.uuid"
                                        name="plugin"
                                        label=""
                                        size="lg"
                                    />
                                </div>
                                <div class="ml-2">
                                    <div
                                        class="text-base font-bold text-gray-600"
                                    >
                                        {{ plan.name }}
                                        <span class="font-normal"
                                            >(${{
                                                plan.price / 100
                                            }}/month)</span
                                        >
                                    </div>
                                    <p
                                        class="mt-1.5 max-w-lg text-gray-500 sm:pr-2 md:pr-4"
                                    >
                                        {{ plan.description }}

                                        <span
                                            v-if="
                                                !plan.uuid.includes('unlimited')
                                            "
                                        >
                                            {{ plan.users_limit }} users
                                            included in plan, additional user
                                            for ${{
                                                plan.users_price
                                                    ? plan.users_price / 100
                                                    : 0
                                            }}/month. Paid monthly.
                                        </span>
                                    </p>
                                </div>
                            </div>
                            <div class="mt-4 shrink-0 sm:mt-0">
                                <AtomicButton
                                    size="md"
                                    color="yellow"
                                    @click="handleOpenOrderModal(plan.uuid)"
                                >
                                    Subscribe now
                                </AtomicButton>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-4">
                    <a
                        href="https://topol.io/tariff-plugin#plugin-pricing"
                        target="_blank"
                        class="cursor-pointer text-sm font-medium text-topol-blue-500"
                    >
                        Compare our Plugin subscription plans
                    </a>
                </div>
            </div>
        </div>

        <div
            v-if="!pluginSubscription && shouldAllowTrial"
            class="mt-4 rounded-md border border-gray-200 bg-gray-50 px-4 pb-[26px] pt-4 sm:px-6 md:pr-[28px]"
        >
            <div class="flex flex-col sm:flex-row sm:justify-between">
                <div>
                    <div class="text-2xl font-bold text-gray-800">
                        Start 14-days FREE Trial
                    </div>
                    <div class="mt-[3px] text-sm text-gray-500">
                        Start your TOPOL Plugin trial by creating API Tokens.
                    </div>
                    <div class="mt-4">
                        <a
                            href="https://docs.topol.io"
                            target="_blank"
                            class="cursor-pointer text-sm font-medium text-topol-blue-500"
                        >
                            How to work with TOPOL Plugin
                        </a>
                    </div>
                </div>

                <div class="mt-4 shrink-0 sm:mt-0">
                    <AtomicButton
                        size="md"
                        color="white"
                        :disabled="loading"
                        @click="handleStartFreeTrial"
                    >
                        Start free trial
                    </AtomicButton>
                </div>
            </div>
        </div>

        <div
            v-if="pluginSubscription"
            class="mt-3 rounded-md border border-gray-200 bg-gray-50 px-6"
        >
            <div
                class="flex flex-col justify-between gap-1 md:flex-row lg:flex-col xl:flex-row"
            >
                <div class="pb-7 pt-6">
                    <div
                        class="inline-flex rounded-md bg-linear-to-r from-[#FFB660] via-[#FF9E4A] to-[#FF8533] px-3 py-[3px] text-xs font-medium text-gray-700"
                    >
                        {{ pluginSubscription.plan?.name }}
                    </div>

                    <div
                        class="mt-5 text-2xl leading-normal tracking-tighter text-gray-800"
                    >
                        <span class="font-bold">
                            ${{
                                pluginSubscription.amount_with_tax
                                    ? (
                                          pluginSubscription.amount_with_tax /
                                          100
                                      ).toFixed(2)
                                    : 0
                            }}
                        </span>
                        <span
                            >/{{
                                pluginSubscription.period === 1
                                    ? 'month'
                                    : 'year'
                            }}
                        </span>
                    </div>

                    <div class="text-sm text-gray-500">
                        {{
                            pluginSubscription.plan?.users_limit
                                ? pluginSubscription.plan.users_limit +
                                  ' prepaid users'
                                : 'Unlimited prepaid users'
                        }}
                    </div>

                    <div
                        v-if="
                            !pluginSubscription.canceled_at &&
                            pluginSubscription.next_billing_date
                        "
                        class="mt-[18px] text-sm"
                    >
                        <div class="text-gray-500">
                            {{
                                pluginSubscription.period === 1
                                    ? 'Month-to-month'
                                    : 'Annual'
                            }}
                            plan
                            <span
                                v-if="
                                    new Date(
                                        pluginSubscription.next_billing_date
                                    ) > new Date()
                                "
                            >
                                renews on
                            </span>
                            <span v-else>was scheduled to renew on</span>
                        </div>

                        <div class="font-medium text-gray-800">
                            {{
                                format(
                                    new Date(
                                        pluginSubscription.next_billing_date
                                    ),
                                    'd MMMM, yyyy'
                                )
                            }}
                        </div>
                    </div>
                    <div
                        v-else-if="pluginSubscription.canceled_at"
                        class="mt-[18px] text-sm text-gray-500"
                    >
                        <div>Subscription canceled, will be active until</div>
                        <div class="font-medium text-gray-800">
                            {{
                                format(
                                    new Date(pluginSubscription.canceled_at),
                                    'd MMMM, yyyy'
                                )
                            }}
                        </div>
                    </div>

                    <div class="mt-7">
                        <inertia-link
                            :href="route('billing.invoices.index')"
                            class="text-sm font-medium leading-normal text-topol-blue-500 hover:text-topol-blue-600"
                            ><p>Your invoices</p></inertia-link
                        >
                    </div>

                    <div
                        v-if="!pluginSubscription.recurring_payment_request"
                        class="mt-[3px] cursor-pointer text-sm font-medium leading-normal text-topol-blue-500 hover:text-topol-blue-600"
                        @click="subscriptionSwitchModal = true"
                    >
                        Change your subscription
                    </div>

                    <div
                        v-else
                        class="mt-[3px] text-sm font-medium leading-normal text-gray-500"
                    >
                        To make changes to your subscription, please contact our
                        support team.
                    </div>
                </div>

                <div class="w-1/3 min-w-[200px] pt-6">
                    <div
                        v-if="
                            pluginSubscription.next_billing_date &&
                            !pluginSubscription.canceled_at
                        "
                    >
                        <div
                            class="inline-flex rounded-md bg-indigo-300 px-3 py-[3px] text-xs font-medium text-gray-700"
                        >
                            Next invoice
                        </div>

                        <div
                            v-if="!dataTrafficUsersLoading"
                            class="mt-5 text-2xl leading-normal tracking-tighter text-gray-800"
                        >
                            <span
                                v-if="!uniqueUsers.addOnQuantity"
                                class="font-bold"
                            >
                                ${{
                                    pluginSubscription.amount_with_tax
                                        ? (
                                              pluginSubscription.amount_with_tax /
                                              100
                                          ).toFixed(2)
                                        : 0
                                }}
                            </span>

                            <span
                                v-if="
                                    uniqueUsers.addOnQuantity &&
                                    uniqueUsers.addOnAmount
                                "
                                class="font-bold"
                            >
                                ${{
                                    pluginSubscription.amount_with_tax
                                        ? (
                                              pluginSubscription.amount_with_tax /
                                                  100 +
                                              addonPrice
                                          ).toFixed(2)
                                        : 0
                                }}
                            </span>
                        </div>

                        <div
                            v-if="!dataTrafficUsersLoading"
                            class="text-sm font-normal text-gray-500"
                        >
                            <div>
                                ${{
                                    pluginSubscription.amount_with_tax
                                        ? (
                                              pluginSubscription.amount_with_tax /
                                              100
                                          ).toFixed(2)
                                        : 0
                                }}
                                basic monthly fee
                            </div>
                            <div
                                v-if="
                                    uniqueUsers.addOnQuantity &&
                                    uniqueUsers.addOnAmount
                                "
                            >
                                +{{ uniqueUsers.addOnQuantity }} users above
                                plan (${{ uniqueUsers.addOnAmount }}/user)
                            </div>
                        </div>
                        <div
                            v-if="dataTrafficUsersLoading"
                            class="mt-5 flex justify-start"
                        >
                            <LoadingSpinner size="medium" />
                        </div>
                    </div>
                </div>

                <div
                    class="border-gray-200 pb-7 pt-6 lg:min-w-[200px] xl:border-l xl:pl-6"
                >
                    <div
                        class="inline-flex rounded-md bg-teal-200 px-3 py-[3px] text-xs font-medium text-gray-700"
                    >
                        Data traffic
                    </div>

                    <div
                        v-if="dataTrafficUsersLoading"
                        class="mt-5 flex justify-start"
                    >
                        <LoadingSpinner size="medium" />
                    </div>
                    <div
                        v-if="!dataTrafficUsersLoading"
                        class="mt-5 text-2xl leading-normal tracking-tighter text-gray-800"
                    >
                        <span v-if="dataTraffic?.price" class="font-bold">
                            ${{ dataTraffic.price.toFixed(2) }}
                        </span>
                        <span v-else class="font-bold"> $0 </span>
                    </div>

                    <div
                        v-if="dataTraffic?.bytes && !dataTrafficUsersLoading"
                        class="text-sm text-gray-500"
                    >
                        for {{ formatBytes(dataTraffic.bytes) }} above limit
                    </div>
                    <div
                        v-if="
                            dataTraffic?.billing_date &&
                            !dataTrafficUsersLoading
                        "
                        class="mt-[39px] text-sm text-gray-500"
                    >
                        <p>Next payment for data traffic on</p>
                        <p class="font-medium text-gray-800">
                            {{
                                format(
                                    new Date(dataTraffic.billing_date),
                                    'd MMMM, yyyy'
                                )
                            }}
                        </p>
                    </div>

                    <div v-if="!dataTrafficUsersLoading" class="mt-7">
                        <inertia-link
                            href="/usage-statistics"
                            class="text-sm font-medium leading-normal text-topol-blue-500 hover:text-topol-blue-600"
                            ><p>Data traffic details</p></inertia-link
                        >
                    </div>
                </div>
            </div>
        </div>

        <SubscriptionOrderModal
            v-if="subscriptionOrderModal"
            :subscription-plans="subscriptionPlans"
            :subscription-plan-uuid="pluginPlanUuid"
            :countries="countries"
            :personal="false"
            :auto-coupon="detectedCoupon"
            @close="closeSubscriptionOrderModal"
            @reopen="reopenSubscriptionOrderModal"
        />

        <PluginSubscriptionSwitchModal
            v-if="pluginSubscription && subscriptionSwitchModal"
            :selected-card="selectedCard"
            :plugin-subscription="pluginSubscription"
            :subscription-plans="subscriptionPlans"
            :active-subscription-plans="activeSubscriptionPlans"
            @close="closeSubscriptionSwitchModal"
            @cancel="handleCancelSubscription"
        />

        <SubscriptionCancelReasonModal
            v-if="subscriptionCancelReasonModal && pluginSubscription?.id"
            :subscription-id="pluginSubscription?.id"
            @close="subscriptionCancelReasonModal = false"
        />
    </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref, watch } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { route } from 'ziggy-js';
import { format } from 'date-fns';
import { ITopolPageProps } from '@/types/TopolPageProps/TopolPageProps';
import { IPaymentMethod } from '@/types/Subscription/IPaymentMethod';
import { router } from '@inertiajs/vue3';
import { create } from '@/composables/useNotifications';
import IExceededTrafficData from '@/types/UsageStatistics/IExceededTrafficData';
import axios from 'axios';
import { formatBytes } from '@utils/formatBytes';
import ISelectable from '@/types/Atomic/ISelectable';
import IPluginUniqueUsers from '@/types/Plugin/IPluginUniqueUsers';
import ISubscription from '@/types/Subscription/ISubscription';
import SubscriptionPlan from '@/types/Subscription/SubscriptionPlan';
import { useCouponUrls } from '@/composables/useCouponUrls';

const props = defineProps<{
    selectedCard?: IPaymentMethod;
    countries: ISelectable[];
    pluginSubscription: ISubscription | null;
    shouldAllowTrial: boolean;
    subscriptionPlans: SubscriptionPlan[];
    activeSubscriptionPlans: SubscriptionPlan[];
}>();

onMounted(async () => {
    if (props.pluginSubscription !== null) {
        dataTrafficUsersLoading.value = true;
        await getDataTraffic();
        await getUniqueUsers();
        dataTrafficUsersLoading.value = false;
    }

    // Initialize coupon detection for plugin subscriptions
    initializeCouponDetection('plugin', props.pluginSubscription);
});

const {
    shouldDisplayPluginTrialBanner,
    shouldDisplayPluginSubscriptionBanner,
} = useBanners();
const { pushEvent } = useGtm();

const {
    detectedCoupon,
    shouldAutoOpen,
    targetPlan,
    initializeCouponDetection,
    clearUrlCoupon,
} = useCouponUrls();

const user = computed(() => usePage<ITopolPageProps>().props.user);
const subscriptionOrderModal = ref(false);
const subscriptionSwitchModal = ref(false);
const subscriptionCancelReasonModal = ref(false);

const orderedSubscriptionPlans = computed(() => {
    return [...props.activeSubscriptionPlans].sort((a, b) => a.price - b.price);
});

const pluginPlanUuid = ref('');
const loading = ref(false);
const uniqueUsers = ref({} as IPluginUniqueUsers);
const dataTrafficUsersLoading = ref(false);
const dataTraffic = ref<IExceededTrafficData>();

const addonPrice = computed(() => {
    if (uniqueUsers.value.addOnQuantity && uniqueUsers.value.addOnAmount) {
        return uniqueUsers.value.addOnQuantity * uniqueUsers.value.addOnAmount;
    } else return 0;
});

const emit = defineEmits<{
    (event: 'subscriptionOrderModalClosed'): void;
    (event: 'subscriptionOrderModalOpened'): void;
    (event: 'subscriptionSwitchModalClosed'): void;
}>();

// Watch for auto-opening modal based on URL coupon
watch(shouldAutoOpen, (shouldOpen) => {
    if (shouldOpen && targetPlan.value && targetPlan.value.planType === 'plugin') {
        handleOpenOrderModal(getSubscriptionPlanUuid());
        clearUrlCoupon(); // Remove coupon from URL after opening
    }
});

// Helper function for subscription plan selection
const getSubscriptionPlanUuid = (): string => {
    // If we have a target plan from coupon, use it
    if (targetPlan.value && targetPlan.value.planType === 'plugin') {
        return targetPlan.value.planUuid;
    }

    // Otherwise use the first available plugin plan as default
    return props.activeSubscriptionPlans.find(plan => plan.type === 'plugin')?.uuid || 'plugin_startup_monthly';
};

const reopenSubscriptionOrderModal = async () => {
    await closeSubscriptionOrderModal();
    subscriptionOrderModal.value = true;
};
const closeSubscriptionOrderModal = () => {
    subscriptionOrderModal.value = false;
    emit('subscriptionOrderModalClosed');
};

const closeSubscriptionSwitchModal = () => {
    subscriptionSwitchModal.value = false;
    emit('subscriptionSwitchModalClosed');
};

const handleStartFreeTrial = () => {
    loading.value = true;
    router.post(
        route('plugin.enable'),
        {},
        {
            onSuccess: () => {
                pushEvent('topol_plugin_trial_start');

                create({
                    title: 'Plugin free trial started',
                    text: 'Plugin has been successfully enabled.',
                    type: 'success',
                });
            },
            onError: () => {
                create({
                    title: 'Plugin free trial not started',
                    text: 'There was an error enabling your Plugin.',
                    type: 'error',
                });
            },
        }
    );
};

const handleOpenOrderModal = async (planUuid: string) => {
    pluginPlanUuid.value = planUuid;
    subscriptionOrderModal.value = true;
    emit('subscriptionOrderModalOpened');
};

const getDataTraffic = async () => {
    try {
        const res = await axios.get(
            route('billing.plugin-subscriptions.data-traffic.index')
        );

        if (res.data.success) {
            dataTraffic.value = res.data.data;
        }
    } catch (error) {
        return;
    }
};

const getUniqueUsers = async () => {
    try {
        const resUsers = await axios.get(
            route('api-tokens.unique-users.index')
        );

        if (resUsers.data.success) {
            uniqueUsers.value = resUsers.data.data;
        }
    } catch (error) {
        return;
    }
};

const handleCancelSubscription = () => {
    subscriptionSwitchModal.value = false;
    subscriptionCancelReasonModal.value = true;
};
</script>

<style scoped></style>
